/** Set when the user finishes the team demo ("Start using the app"). */
export const EXPERIENCE_SEEN_TEAM_DEMO_KEY = "experience_seen_team_demo";

export function getHasSeenTeamDemo(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(EXPERIENCE_SEEN_TEAM_DEMO_KEY) === "true";
}

export function setHasSeenTeamDemo(): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(EXPERIENCE_SEEN_TEAM_DEMO_KEY, "true");
}
